import * as PIXI from 'pixi.js'
import { trace } from 'rytm-helpers'
import { scaleToPx, absPositionX, absPositionY, relPositionX, relPositionY } from './../lib/math_helpers'


class TextObject {
  /**
  * TextObject class constructor  
  * @constructor
  **/
  constructor(params) {
    this.txt = params.txt
    this.bar = params.bar // bar number
    this.onStage = false
    this.x = 0
    this.y = 0
  }
  /**
   * Add to stage
   */
  addToStage(container) {
    container.addChild(this.sprite)
    this.onStage = true
  }
  
  /**
   * Destroy
   */
  destroy() {
    this.onStage = false
    if (this.sprite) {
      this.sprite.parent.removeChild(this.sprite)
      this.sprite = null
      // trace("Destroy!", this.uid, this)
    }
  }
  buildText() {
    this.sprite = new PIXI.Text(this.txt, {fontFamily : 'Arial', fontSize: 14, fill : 0x000000, align : 'left'});
  }
  
  /**
   * Set position relative to window width
   * @param {Object} params 
   */
  setPosition(params) {
    this.x = params.x ? params.x : this.x
    this.y = params.y ? params.y : this.y
    this._update()
  }
  onWindowResize() {
    this._update()
  }
  
  
  /** 
   * ### PRIVATE METHODS ###
   */
  _update() {
    if (this.sprite) {      
      this.sprite.x = absPositionX(this.x)
      this.sprite.y = absPositionX(this.y)
    }
  }
  

}

export default TextObject;
